import {
  bumiOnboardingABTestRouteConfig,
  getABTestConfig,
} from '@/config/abTestConfig'
import ABTestSectionOutlet from '@app-studio-web/ui/components/ABTestSectionOutlet'

export default function BumiOnboardingOutlet() {
  return (
    <ABTestSectionOutlet
      basePath="/onboarding"
      routeConfig={bumiOnboardingABTestRouteConfig}
      getABTestConfig={getABTestConfig}
      validVariants={['baseline']}
    />
  )
}
